import qs from 'qs'

/**
 * Invited offshore users open join with ?offshore=true&invitation=<uuid>.
 * Single source of truth for parsing (JoinContext, account check, details step).
 *
 * @param {string} search - e.g. window.location.search or a query substring
 * @returns {{ isActive: boolean, invitationId: string | null }}
 */
export function parseOffshoreJoinQuery(search) {
  if (!search || typeof search !== 'string') {
    return { isActive: false, invitationId: null }
  }

  const trimmed = search.startsWith('?') ? search.slice(1) : search
  const parsedQuery = qs.parse(trimmed, { ignoreQueryPrefix: true })
  const invitationParam = parsedQuery.invitation
  const isActive = Boolean(parsedQuery.offshore && invitationParam)

  return {
    isActive,
    invitationId: isActive ? String(invitationParam) : null,
  }
}
